import gql from 'graphql-tag'

const expeditionItemsGetQuery = gql`
  query expeditionItemsGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object, $nested: Boolean) {
    expeditionItemsGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: $nested })
      @rest(type: "ExpeditionItemsResult", method: "POST", path: "expedition-item/list") {
      results
      paging
    }
  }
`

export default expeditionItemsGetQuery
